"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsOverLg = exports.useIsOverMd = exports.useIsUnderLg = exports.useIsUnderMd = exports.useIsUnderSm = exports.useIsUnderXs = exports.useIsUnderXxs = exports.calcBreakpoint = void 0;
var useMediaQuery_1 = require("@hooks/useMediaQuery");
var breakpoints = {
    xxs: 0,
    xs: 376,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
};
var calcBreakpoint = function (width) {
    if (breakpoints.xxs <= width && width < breakpoints.xs) {
        return "xxs";
    }
    if (breakpoints.xs <= width && width < breakpoints.sm) {
        return "xs";
    }
    if (breakpoints.sm <= width && width < breakpoints.md) {
        return "sm";
    }
    if (breakpoints.md <= width && width < breakpoints.lg) {
        return "md";
    }
    if (breakpoints.lg <= width && width < breakpoints.xl) {
        return "lg";
    }
    return "xl";
};
exports.calcBreakpoint = calcBreakpoint;
var useIsUnderXxs = function () {
    return (0, useMediaQuery_1.useMedia)("(max-width: ".concat(breakpoints.xs - 1, "px)"));
};
exports.useIsUnderXxs = useIsUnderXxs;
var useIsUnderXs = function () {
    return (0, useMediaQuery_1.useMedia)("(max-width: ".concat(breakpoints.sm - 1, "px)"));
};
exports.useIsUnderXs = useIsUnderXs;
var useIsUnderSm = function () {
    return (0, useMediaQuery_1.useMedia)("(max-width: ".concat(breakpoints.md - 1, "px)"));
};
exports.useIsUnderSm = useIsUnderSm;
var useIsUnderMd = function () {
    return (0, useMediaQuery_1.useMedia)("(max-width: ".concat(breakpoints.lg - 1, "px)"));
};
exports.useIsUnderMd = useIsUnderMd;
var useIsUnderLg = function () {
    return (0, useMediaQuery_1.useMedia)("(max-width: ".concat(breakpoints.xl - 1, "px)"));
};
exports.useIsUnderLg = useIsUnderLg;
var useIsOverMd = function () { return (0, useMediaQuery_1.useMedia)("(min-width: ".concat(breakpoints.md, "px)")); };
exports.useIsOverMd = useIsOverMd;
var useIsOverLg = function () { return (0, useMediaQuery_1.useMedia)("(min-width: ".concat(breakpoints.lg, "px)")); };
exports.useIsOverLg = useIsOverLg;
